import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IFormOfferings } from 'legacy/lut/classes/models/partner360/IFormOfferings'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { updateFormDataField } from 'cng-common/features/form'
import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

import {
  selectQBREntryId,
  selectQBRFYear,
  selectQBRRtm,
} from '../../../../../../../../../../../../features/QBR'
import { QBR_SETTINGS_FORM_KEY } from '../../../index'

export const useOfferingsForRtm = () => {
  const [offeringsForCurrentRtm, setOfferingsForCurrentRtm] = useState<IFormOfferings[]>([])
  const [wip, setWip] = useState(true)

  const documentEntryId = useSelector(selectQBREntryId)
  const fYear = useSelector(selectQBRFYear)
  const qbrRtm = useSelector(selectQBRRtm)
  const dispatch = useAppDispatch()

  const offeringsCrud = CrudStore.get(
    CrudStoreItemPartner360.JBPOfferings,
    'global-partner-offerings'
  )

  useEffect(() => {
    setWip(true)

    offeringsCrud.setPaging({ page: 0, pageSize: 100 })
    offeringsCrud.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'FYear',
          operator: Operator.EQUAL,
          value: fYear,
        },
        {
          field: 'PartnerType',
          value: qbrRtm,
          operator: Operator.EQUAL,
        },
      ],
    })

    offeringsCrud.fetch().then((offeringsRes) => {
      const offeringsForCurrentRtm: IFormOfferings[] = offeringsRes.items
        .map((el) => ({
          ...el,
          Links: JSON.parse(el.Links || '') || [],
        }))
        .filter((el: IFormOfferings) => !el.IsDeprecated)

      setOfferingsForCurrentRtm(offeringsForCurrentRtm)

      if (!documentEntryId) {
        const preSelectedValues = offeringsForCurrentRtm
          .filter((el) => el.IsDefault)
          .map((el) => el.Offering)
        dispatch(
          updateFormDataField({
            formKey: QBR_SETTINGS_FORM_KEY,
            field: 'offerings',
            value: preSelectedValues,
          })
        )
      }

      setWip(false)
    })
  }, [fYear, qbrRtm, offeringsCrud, documentEntryId, dispatch])

  return {
    wip,
    offeringsForCurrentRtm,
  }
}
